import { render, staticRenderFns } from "./TransactionsHeader.vue?vue&type=template&id=b08008f4&scoped=true&"
import script from "./TransactionsHeader.vue?vue&type=script&lang=js&"
export * from "./TransactionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHeader.vue?vue&type=style&index=0&id=b08008f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08008f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
